/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import MainHeader from "../../../../Shared/components/Header";
import PurchaseIcon from "../../../../../assets/images/icon_menus/PurchaseIcon.json";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import Typography from '@mui/material/Typography';
import { Col, Row, Space } from "antd";
import { Button } from "@mui/material";
import crudActions from "../../../../CRUD/redux/actions";
import usePrevious from "../../../../Shared/components/Previous";
import { QuickLinks } from "../../../../Shared/components/BreadCrumbNew/QuickLinks";
import { CustomAccordion } from "../../../../Shared/components/AccordionComponent";
import qucikLinksActions from "../../../../Dashboard/redux/actions";
import { capitalizeFirstLetter, checkCRUDViewPermission, checkCRUDPermission, idNamingConversion } from "../../../../../helpers/utilities";
import DeleteModal from "../../../../Shared/components/DeleteModal";
import { AESEncrypt, AESDecrypt } from "../../../../../helpers/Crypto";
import PurchasePrice from "../../../../Product/Setup/components/Price/PurchasePrice";
import { PurchasePriceHead } from "../../../../../config/constant";
import productActions from "../../../../Product/Product/redux/actions";
import { useEventListener } from "../../../../../helpers/useEventListener";


const SupplierView = (props) => {
    const { readDetails, readError } = useSelector(state => state.crudReducer);
    const { roleManagement } = useSelector(state => state.authReducer);
    const { supplierId } = useParams();
    const [name, setName] = useState('');
    const prevReadDetails = usePrevious(readDetails);
    const dispatch = useDispatch();
    const [deleteModal, setDeleteModal] = useState(false);
    const { history } = props;
    const [factBox, setFactBox] = useState([]);
    const [showDetails, setShowDetails] = useState(true);
    const childRef = useRef('');
    const decryptedId = AESDecrypt(supplierId);

    const priceRef = useRef('');
    const apiUrl = useState('purchase-prices');


    const handleDeleteModal = (value) => {
        setDeleteModal(value);
    }

    const onDelete = (data) => {
        setDeleteModal(true);
        setName(data.name);
    }

    const menus = [
        {
            "name": "Payment Details",
            "link": `/purchase/purchase-management/all-suppliers/${AESEncrypt(decryptedId)}/paymentDetailsView`
        },
        {
            "name": "Create Order",
            "link": ""
        },
        {
            "name": "Create Self Bill",
            "link": `/purchase/purchase-management/self-bill/${AESEncrypt(decryptedId)}/create`
        },
        {
            "name": "Make Payment",
            "link": `/purchase/purchase-management/supplier-payment/${AESEncrypt(decryptedId)}/create`
        },
        {
            "name": "Invoice History",
            "link": `/purchase/transactions/${AESEncrypt(decryptedId)}/invoice-history`
        },
        {
            "name": "Order History",
            "link": ""
        },
        {
            "name": "Planned Orders",
            "link": ""
        },
        {
            "name": "Settlement",
            "link": `/purchase/report-and-enquiry/${AESEncrypt(decryptedId)}/supplier-settlement`
        },
        {
            "name": "Transaction History",
            "link": `/purchase/transactions/${AESEncrypt(decryptedId)}/supplier-transactions`
        }
    ];

    const loadTasksDelete = () => {
        history.push("/purchase/purchase-management/all-suppliers");
    }

    useEffect(() => {
        if (prevReadDetails !== undefined && readDetails && prevReadDetails !== readDetails) {
            if (readDetails.isHold) {
                menus.splice(2, 2);
            }
            if (readDetails.facts) {
                setFactBox(readDetails.facts);
                if (readDetails.isNew) {
                    let iH = menus.findIndex((d, i) => d.name === 'Invoice History');
                    menus[iH]['disabled'] = true;
                    let oH = menus.findIndex((d, i) => d.name === 'Order History');
                    menus[oH]['disabled'] = true;
                    let s = menus.findIndex((d, i) => d.name === 'Settlement');
                    menus[s]['disabled'] = true;
                    let tH = menus.findIndex((d, i) => d.name === 'Transaction History');
                    menus[tH]['disabled'] = true;
                    let pO = menus.findIndex((d, i) => d.name === 'Planned Orders');
                    menus[pO]['disabled'] = true;
                }
                setTimeout(function () {
                    dispatch({
                        type: qucikLinksActions.QUICKLINKS_START, menus: menus, toggle: true,
                        factBox: readDetails.facts, component: "All Suppliers"
                    });
                    childRef?.current?.handleAdjustHeight();
                }, 200)
            }
            setShowDetails(false);
        }
    }, [readDetails, readError]);


    useEffect(() => {
        if (decryptedId === 0) {
            loadTasksDelete();
        } else {
            if (roleManagement !== '' && checkCRUDViewPermission('All Suppliers', 'view', history, 'Purchase')) {
                dispatch({
                    type: productActions.MYPRODUCT_DETAILS_START, url: 'client-products', filter: {
                        where: { "and": [{ status: 'ACTIVE' }] },
                        order: 'id  desc'
                    }
                });
                dispatch({ type: crudActions.READ_DETAILS_START, id: decryptedId, url: "supplierProfile" });
            }
        }

    }, [supplierId, roleManagement]);

    const handleKeyDown = (e) => {
        if (e.altKey && e.keyCode === 69) {
            e.preventDefault();
            history.push(`/purchase/purchase-management/all-suppliers/${AESEncrypt(decryptedId)}/edit`);
        } else if (e.altKey && e.keyCode === 66) {
            e.preventDefault();
            history.push(`/purchase/purchase-management/self-bill/${AESEncrypt(decryptedId)}/create`);
        } else if (e.altKey && e.keyCode === 84) {
            e.preventDefault();
            history.push(`/purchase/transactions/${AESEncrypt(decryptedId)}/supplier-transactions`);
        } else if (e.altKey && e.keyCode === 73) {
            e.preventDefault();
            history.push(`/purchase/transactions/${AESEncrypt(decryptedId)}/invoice-history`);
        } else if (e.altKey && e.keyCode === 80) {
            e.preventDefault();
            history.push(`/purchase/purchase-management/supplier-payment/${AESEncrypt(decryptedId)}/create`);
        } else if (e.altKey && e.keyCode === 77) {
            e.preventDefault();
            history.push(`/purchase/report-and-enquiry/${AESEncrypt(decryptedId)}/supplier-settlement`);
        }
    }

    useEventListener("keydown", handleKeyDown);

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader {...props}
                img={PurchaseIcon}
                title={'Purchase'}
                closeLink={'/purchase/purchase-management/all-suppliers'}
                links={[{ 'label': 'Purchase', 'link': '/purchase' }, { 'label': 'All Suppliers', 'link': '/purchase/purchase-management/all-suppliers' }, { 'label': 'Supplier Details', 'link': '' }]}
            />
            <div className={clsx(classes.margin40, classes.listTableMargin, classes.listTableSticky, { [classes.scrollBorder]: !showDetails })}>
                <div id="containerDiv" className={clsx(classes.stickyContainer)}>
                    <CustomAccordion
                        title={'View Supplier'}
                        top={"0"}
                        topVisible={"50px"}
                        zIndex={9}
                        showDetails={showDetails}
                        index={0}
                        ref={childRef}
                        component={
                            <>
                                {
                                    showDetails === false && readDetails &&
                                    <>
                                        <Row gutter={50}>
                                            <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={8} >
                                                <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.bold)}>General</Typography>
                                            </Col>
                                            <Col xxl={19} xl={19} lg={19} md={19} sm={12} xs={16} className={classes.textAlignRight}><Space direction="horizontal" align="center" >
                                                {
                                                    roleManagement !== '' && readDetails?.isNew && checkCRUDPermission('All Suppliers', 'deletable', 'Purchase') && <Button
                                                        key="delete"
                                                        onClick={() => onDelete(readDetails)}
                                                        color="primary"
                                                        variant="contained"
                                                        id={idNamingConversion('Delete', 'supplierProfile', 'Button')}
                                                        className={clsx(classes.deleteBtn)}>
                                                        Delete</Button>
                                                }
                                                {
                                                    roleManagement !== '' && checkCRUDPermission('All Suppliers', 'edit', 'Purchase') &&
                                                    <Link id={idNamingConversion('Edit', 'supplierProfile', 'Link')} to={`/purchase/purchase-management/all-suppliers/${supplierId}/edit`} className={clsx(classes.modalBtn, classes.bold, classes.marginRight0)}>Edit</Link>
                                                }
                                            </Space>
                                            </Col>
                                            <Col xxl={10} xl={10} lg={6} md={8} sm={12} xs={24}>
                                                <Typography className={clsx(classes.aTitle, classes.margin10t)}>{readDetails.name}</Typography>
                                                <Typography variant={'subtitle1'} className={clsx(classes.fonSize13)}><span className={clsx(classes.bold, classes.colorLine)}>{readDetails.serialNo}</span>
                                                    <span className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}> {readDetails.type}</span></Typography>
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24} className={classes.mobileViewHoldSupplier}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.margin10t, 'MuiInputLabel-shrink', classes.fonSize13)}>Hold</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails?.isHold ? 'Yes' : 'No'}</Typography>
                                            </Col>
                                            <Col xxl={9} xl={9} lg={24} md={24} sm={24} xs={24}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.margin10t, 'MuiInputLabel-shrink', classes.fonSize13)}>Price Includes Tax</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails?.priceIncludesTax ? 'Yes' : 'No'}</Typography>
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin30t, classes.fonSize13)}>Mobile Number</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.mobile}</Typography>
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Email</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.email ? readDetails.email : '---'}</Typography>
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Classification</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{capitalizeFirstLetter(readDetails?.classification || '---')}</Typography>
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Preferred Language</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.language ? readDetails?.language?.name : '---'}</Typography>
                                            </Col>
                                            <Col xxl={4} xl={4} lg={6} md={8} sm={12} xs={24} >
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Group</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.group ? readDetails.group.name : '---'}</Typography>
                                            </Col>
                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} >
                                                <Typography variant={'h6'} className={clsx(classes.customLink, classes.margin35t, classes.typographyHeader, classes.bold)}>GST Details</Typography>
                                            </Col>
                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                <Row gutter={50} className={classes.marginTop10}>
                                                    <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>GST Type </Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails?.taxType?.name || '---'}</Typography>
                                                    </Col>
                                                    <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24} >
                                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>GST Code</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.partyGst ? readDetails.partyGst.code : '---'}</Typography>
                                                    </Col>
                                                    <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24} >
                                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>GST Number (GSTIN)</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.gstin ? readDetails.gstin : '---'}</Typography>
                                                    </Col>
                                                    <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24} >
                                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Identity Number</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.pan ? readDetails.pan : '---'}</Typography>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} >
                                                <Typography variant={'h6'} className={clsx(classes.customLink, classes.margin35t, classes.typographyHeader, classes.bold)}>Address</Typography>
                                            </Col>
                                            <Col xxl={10} xl={10} lg={12} md={12} sm={12} xs={24}>
                                                <Row gutter={50}>
                                                    <Col xxl={12} xl={12} lg={16} md={16} sm={12} xs={24}>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14, classes.margin20t)}>{readDetails.address1 || '---'}</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.area ? readDetails.area.name : '---'}</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.city ? readDetails.city.name : '---'}</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.state ? readDetails.state.name : '---'}</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.country ? readDetails.country.name : '---'}</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.pincode ? readDetails.pincode.code : '---'}</Typography>
                                                    </Col>
                                                </Row>
                                            </Col>

                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} >
                                                <Typography variant={'h6'} className={clsx(classes.customLink, classes.margin35t, classes.typographyHeader, classes.bold)}>Other Contact Details</Typography>
                                            </Col>
                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                <Row gutter={50} className={classes.marginTop10}>
                                                    <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Contact Name</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.contactName ? readDetails.contactName : '---'}</Typography>
                                                    </Col>
                                                    <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Alternate Name (Optional)</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.tradingName ? readDetails.tradingName : '---'}</Typography>
                                                    </Col>
                                                    <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24} >
                                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Alternate Phone</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.alternateMobile ? readDetails.alternateMobile : '---'}</Typography>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} >
                                                <Typography variant={'h6'} className={clsx(classes.customLink, classes.margin35t, classes.typographyHeader, classes.bold)}>Payment Info</Typography>
                                            </Col>
                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                <Row gutter={50} className={classes.marginTop10}>
                                                    <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24} >
                                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Method of payment (MOP)</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.mop ? readDetails.mop.method : '---'}</Typography>
                                                    </Col>
                                                    <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24} >
                                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Currency</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.currency ? readDetails.currency.name : '---'}</Typography>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} >
                                                <Typography variant={'h6'} className={clsx(classes.customLink, classes.margin35t, classes.typographyHeader, classes.bold)}>Younote Info</Typography>
                                            </Col>
                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                <Row gutter={50} className={classes.marginTop10}>

                                                    <Col xxl={5} xl={5} lg={6} md={8} sm={8} xs={24} >
                                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Younote ID</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails?.supplierBusiness?.serialNo || '---'}</Typography>
                                                    </Col>
                                                    <Col xxl={5} xl={5} lg={6} md={8} sm={8} xs={24} >
                                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>In-App Status</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.inAppStatus ? capitalizeFirstLetter(readDetails.inAppStatus) : 'No'}</Typography>
                                                    </Col>
                                                    <Col xxl={5} xl={5} lg={6} md={8} sm={8} xs={24} >
                                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>In-AppTransactions</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.inAppTransition ? 'Yes' : 'No'}</Typography>
                                                    </Col>

                                                </Row>
                                            </Col>
                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                <Typography variant={'h6'} className={clsx(classes.customLink, classes.margin35t, classes.typographyHeader, classes.bold)}>Other Taxes</Typography>
                                            </Col>
                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                <Row gutter={50} className={classes.marginTop10}>
                                                    <Col xxl={5} xl={5} lg={6} md={8} sm={8} xs={24}>
                                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Cash Discount</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails?.cashDiscount?.code || '---'}</Typography>
                                                    </Col>
                                                    <Col xxl={5} xl={5} lg={6} md={8} sm={8} xs={24}>
                                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Tax Code</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails?.taxCode?.code || '---'}</Typography>
                                                    </Col>
                                                    <Col xxl={5} xl={5} lg={6} md={8} sm={8} xs={24}>
                                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>TCS</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.tcsBoolean ? 'Yes' : 'No'}</Typography>
                                                    </Col>
                                                    <Col xxl={5} xl={5} lg={6} md={8} sm={8} xs={24}>
                                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>TDS</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.tdsBoolean ? 'Yes' : 'No'}</Typography>
                                                    </Col>
                                                    <Col xxl={4} xl={4} lg={6} md={8} sm={12} xs={24}>
                                                        {
                                                            readDetails.tcsBoolean ? <>
                                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>TCS Type</Typography>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails?.tcs?.name || '---'}</Typography>
                                                            </> : ''
                                                        }
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </>
                                }
                                {
                                    showDetails === true && (
                                        <div style={{ textAlign: "center" }}>
                                            <div className={classes.loadMoreCircle}></div>
                                        </div>
                                    )
                                }
                            </>
                        }
                    />
                    <CustomAccordion
                        title={'Purchase Price Details'}
                        top={"49"}
                        topVisible={"150px"}
                        zIndex={7}
                        showDetails={showDetails}
                        index={1}
                        ref={childRef}
                        component={<>
                            {
                                showDetails === false ? readDetails &&
                                    <PurchasePrice topBarView={false}
                                        ref={priceRef}
                                        supplierId={decryptedId}
                                        title={"Purachase Price"}
                                        {...props}
                                        apiUrl={apiUrl} heads={PurchasePriceHead} /> : <div className={classes.textAlignCenter}>
                                    <div className={classes.loadMoreCircle}></div>
                                </div>
                            }
                        </>}
                    />
                    {/* <CustomAccordion
                        title={'Supplier Products'}
                        top={"113"}
                        topVisible={"250px"}
                        zIndex={5}
                        showDetails={showDetails}
                        index={2}
                        ref={childRef}
                        component={<></>}
                    />
                    <CustomAccordion
                        title={'Minimum Stock Quantity'}
                        top={"178"}
                        topVisible={"300px"}
                        zIndex={3}
                        showDetails={showDetails}
                        index={3}
                        ref={childRef}
                        component={<></>}
                        lastContent={true}
                    /> */}
                </div>
            </div>
            <DeleteModal onClose={(v) => handleDeleteModal(v)}
                id={decryptedId} loadTasks={() => loadTasksDelete()}
                name={name} url={'supplierProfile'} title={'Supplier Profile'} visible={deleteModal} />
            <QuickLinks menus={menus} component={"All Suppliers"} factBox={factBox} onParentFunction={() => childRef?.current?.handleAdjustHeight()} />
        </React.Fragment>
    )
}
export default SupplierView